export function getDefaultClientDeliveryMessage(
  domain?: null | string,
  targetUrl?: string,
): string {
  const currentUrl = new URL(targetUrl ?? window.location.href);

  currentUrl.searchParams.delete("openUpload");

  if (domain) {
    currentUrl.host = domain;
    currentUrl.protocol = "https:";
  }

  const dynamicLink = currentUrl.toString();

  return `<p>Hello [@Client's Name],</p>
    <p>I'm excited to share the designs we've been working on. Please find them attached for your review. I look forward to hearing your thoughts and any feedback you may have. Thanks!</p>
    <br />
    <p><a href="${dynamicLink}">📎 View your designs here</a></p>
    `;
}
